import { useState } from 'react';
import PageHero from '../shared/PageHero.jsx';
import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { galleryItems, galleryTabs } from '../constants/gallery.js';

export default function Gallery() {
  const [category, setCategory] = useState('all');

  const shown = galleryItems.filter(
    (item) => category === 'all' || item.category === category,
  );

  return (
    <>
      <Seo {...metaFor('/gallery')} path="/gallery" />

      <PageHero
        eyebrow="Gallery"
        title="A normal week, photographed."
        lede="No staged shots and no stock photography — every picture here was taken by a teacher on an ordinary school day."
      >
        {/*
          A filter, not navigation: the tabs swap what the grid below shows, so
          they are buttons with aria-pressed rather than links or a tablist.
        */}
        <div className="mt-5.5 flex flex-wrap gap-2.5">
          {galleryTabs.map((tab) => {
            const on = tab.id === category;

            return (
              <button
                key={tab.id}
                type="button"
                aria-pressed={on}
                onClick={() => setCategory(tab.id)}
                className={`cursor-pointer rounded-full border-2 px-[17px] py-[9px] text-sm font-bold transition-colors ${
                  on
                    ? 'border-forest bg-forest text-cream'
                    : 'border-sage bg-white text-ink-mute hover:border-forest'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </PageHero>

      <section className="bg-cream pb-20 pt-2">
        <div className="mx-auto grid max-w-[1240px] auto-rows-[210px] grid-cols-2 gap-4 px-5 sm:px-8 lg:grid-cols-4">
          {shown.map((item, i) => (
            <Reveal
              // Keyed on the filter too, so switching category re-runs the
              // reveal instead of leaving swapped-in tiles stuck invisible.
              key={`${category}-${item.id}`}
              index={i}
              className={`overflow-hidden rounded-[22px] border-[3px] border-white bg-mint shadow-[0_8px_20px_rgb(20_83_45_/_0.12)] ${
                item.span === 2 ? 'col-span-2' : ''
              }`}
            >
              <ImageSlot caption={item.caption} alt={item.caption} />
            </Reveal>
          ))}
        </div>

        {shown.length === 0 && (
          <p className="mx-auto mt-8 max-w-[1240px] px-5 text-ink-soft sm:px-8">
            Nothing in this album yet.
          </p>
        )}
      </section>
    </>
  );
}
